module.exports = "/_next/static/images/DefaultStoreFlowersItemImage-4329c6733a76e9db889a9157cecefa98.jpg";